import type { StoreApi } from "zustand";

import type { AskPerformYardState } from "./types";

// Lazy store reference — set by store/index.ts after creation to avoid circular imports.
let storeRef: StoreApi<AskPerformYardState> | null = null;

export const setStoreRef = (store: StoreApi<AskPerformYardState>): void => {
	storeRef = store;
};

// Streaming chunk buffer — accumulates chunks and flushes once per animation frame
// to avoid triggering a full re-render on every tiny chunk
let pendingChunks = "";
let pendingMessageId: string | null = null;
let rafHandle: number | null = null;

export const flushPendingChunks = (): void => {
	rafHandle = null;
	const chunks = pendingChunks;
	const messageId = pendingMessageId;
	pendingChunks = "";
	pendingMessageId = null;

	if (!messageId || !chunks) return;

	storeRef?.setState((state) => {
		const lastIdx = state.messages.length - 1;
		const lastMsg = state.messages[lastIdx];
		if (!lastMsg || lastMsg.id !== messageId) return state;

		const updated = state.messages.slice();
		updated[lastIdx] = { ...lastMsg, content: lastMsg.content + chunks };
		return { messages: updated };
	});
};

export const drainPendingChunks = (): string => {
	if (rafHandle !== null) {
		cancelAnimationFrame(rafHandle);
		rafHandle = null;
	}
	const chunks = pendingChunks;
	pendingChunks = "";
	pendingMessageId = null;
	return chunks;
};

export const schedulePendingChunk = (messageId: string, chunk: string): void => {
	pendingMessageId = messageId;
	pendingChunks += chunk;
	if (rafHandle === null) {
		rafHandle = requestAnimationFrame(flushPendingChunks);
	}
};
